var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { flexGrow: 1 } },
    [
      _vm.items.length != 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-list",
                { staticClass: "no-padding" },
                [
                  _c("b", { staticClass: "sub-title" }, [
                    _vm._v(_vm._s(_vm.$ct("added-files"))),
                  ]),
                  _vm._l(_vm.items, function (item, index) {
                    return _c(
                      "w-list-item",
                      { key: item.ID },
                      [
                        _c(
                          "w-list-item-icon",
                          [_c("w-fa", { attrs: { icon: ["far", "file"] } })],
                          1
                        ),
                        item.File
                          ? _c("w-list-item-text", [
                              _vm._v(_vm._s(item.File.Name)),
                            ])
                          : _vm._e(),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.download"),
                                    expression: "$ct('common.download')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.download(item)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "download" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.delete"),
                                    expression: "$ct('common.delete')",
                                  },
                                ],
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeStoredFile(index, item)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _c(
            "w-card-content",
            { staticClass: "list-empty-root" },
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12", center: "" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("empty-list")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
      _vm.hasModule
        ? _c(
            "w-card-content",
            [
              _vm.car.UnprocessedFiles.length != 0
                ? _c(
                    "w-list",
                    { staticClass: "no-padding" },
                    [
                      _c("b", { staticClass: "sub-title" }, [
                        _vm._v(_vm._s(_vm.$ct("waiting-files"))),
                      ]),
                      _vm._l(_vm.car.UnprocessedFiles, function (item, index) {
                        return _c(
                          "w-list-item",
                          { key: index },
                          [
                            _c(
                              "w-list-item-icon",
                              [
                                _c("w-fa", {
                                  attrs: { icon: ["far", "file"] },
                                }),
                              ],
                              1
                            ),
                            _c("w-list-item-text", [_vm._v(_vm._s(item.name))]),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("common.delete"),
                                        expression: "$ct('common.delete')",
                                      },
                                    ],
                                    staticClass: "danger",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeFile(index)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "trash" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c("app-file-upload", {
                attrs: {
                  label: _vm.$ct("drop-your-images"),
                  sending: _vm.sending,
                },
                on: {
                  input: function ($event) {
                    return _vm.onFile($event)
                  },
                },
              }),
              _vm.car.ID > 0 && _vm.car.UnprocessedFiles.length != 0
                ? _c(
                    "w-button",
                    {
                      staticClass: "mt",
                      on: {
                        click: function ($event) {
                          return _vm.upload()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("upload-files")))]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }